






































  import { Component } from 'vue-property-decorator'
  import { mixins } from 'nuxt-property-decorator'
  import { namespace } from 'vuex-class'
  import { Products } from '@one/types'
  import CurrentProductMixin from '~/mixins/CurrentProduct'

  const products = namespace('products')

  interface Relation {
    productId: string
    value: string
  }

  interface RelationOptions {
    key: string
    label: string
  }

  @Component
  export default class OneProductRelations extends mixins<CurrentProductMixin>(CurrentProductMixin) {
    @products.Getter getAttributesValue: any
    @products.Action fetchProduct: any

    relationLength(relations: Relation[]): boolean {
      // If length is less than 4, then display relations with blocks
      return relations.length < 4
    }

    relationsSelect(relations: Relation[]): Array<RelationOptions> {
      return relations.map((item) => {
        return {
          key: item.productId,
          label: item.value,
        }
      })
    }

    getCurrentRelationValue(relations: Relation[]): RelationOptions | undefined {
      if (!this.$product?.id) {
        return undefined
      }
      const currentRelation = relations.find(item => item.productId === this.$product!.id)
      return currentRelation ? { key: currentRelation.productId, label: currentRelation.value } : undefined
    }

    async onRelationClick(relationIndex: string) {
      const product: Products.Product = await this.fetchProduct(relationIndex)
      this.$router.push(this.$routes.getProductPath(product))
    }
  }
